import { render, staticRenderFns } from "./SelectedOptionDropdownOpen.vue?vue&type=template&id=8ff74c48"
import script from "./SelectedOptionDropdownOpen.vue?vue&type=script&lang=js"
export * from "./SelectedOptionDropdownOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports